import(/* webpackMode: "eager" */ "/vercel/path0/app/(dashboard)/error.tsx");
